import { render } from "./ChangeUserDataModal.vue?vue&type=template&id=74747f3c&scoped=true"
import script from "./ChangeUserDataModal.vue?vue&type=script&lang=js"
export * from "./ChangeUserDataModal.vue?vue&type=script&lang=js"

import "./ChangeUserDataModal.vue?vue&type=style&index=0&id=74747f3c&scoped=true&lang=css"

import exportComponent from "/app/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74747f3c"]])

export default __exports__